import vancouver from './cities/vancouver'
import burnaby from './cities/burnaby'
import victoria from './cities/victoria'

export default {
  province: 'British Columbia',
  abbr: 'B.C.',
  alpha: 'BC',
  lawSociety: 'Law Society of British Columbia',
  writeup: '',
  cities: [burnaby, vancouver, victoria]
}



// WEBPACK FOOTER //
// ./src/store/provinces/britishColumbia/index.js